import script from "./backToOverviewPage.vue?vue&type=script&setup=true&lang=js"
export * from "./backToOverviewPage.vue?vue&type=script&setup=true&lang=js"

import "./backToOverviewPage.vue?vue&type=style&index=0&id=54e3af31&lang=scss&scoped=true"

import exportComponent from "/home/steffen/Projekte/clubadmin/frontend/homepage/gc-schoenbuch/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-54e3af31"]])

export default __exports__